export const ADD_CONFIG_SYSTEM = 'ADD_CONFIG_SYSTEM';
export const UPDATE_CONFIG_SYSTEM = 'UPDATE_CONFIG_SYSTEM';
export const DELETE_CONFIG_SYSTEM = 'DELETE_CONFIG_SYSTEM';

export const addConfigDataSystem = (data) => ({
    type: ADD_CONFIG_SYSTEM,
    data: data
});

export const updateConfigDataSystem = (data) => ({
    type: UPDATE_CONFIG_SYSTEM,
    data: data
});

export const deleteConfigDataSystem = () => ({
    type: DELETE_CONFIG_SYSTEM
});
